import { Box, TextField } from "@mui/material";
import { SoftButton } from "../soft/SoftKit";
import { useScriptMode } from "../../../contexts/ScriptModeContext";

function pad(n) { return String(n).padStart(2, "0"); }

function shiftMonth(monthKey, delta) {
  const [y, m] = monthKey.split("-").map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}`;
}

export default function HatimMonthPicker({ value, onChange }) {
  const { t } = useScriptMode();

  return (
    <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
      <SoftButton tone="soft" size="small" onClick={() => onChange(shiftMonth(value, -1))}>
        {t("hatim_prev_month")}
      </SoftButton>
      <TextField
        type="month"
        size="small"
        label={t("hatim_month_label")}
        value={value}
        onChange={(e) => {
          if (/^\d{4}-\d{2}$/.test(e.target.value)) {
            onChange(e.target.value);
          }
        }}
        InputLabelProps={{ shrink: true }}
      />
      <SoftButton tone="soft" size="small" onClick={() => onChange(shiftMonth(value, 1))}>
        {t("hatim_next_month")}
      </SoftButton>
    </Box>
  );
}
